export const css = {
    root: '_21Gj87QG',
    header: '_3T3Tk1fU',
    headerContent: '_47IhSF5K',
    avatar: 'XkjaFLb2',
    title: '_20EP58aL',
    subtitle: '_3Ns1BxJe',
    ' _key': 'certwise-theme/dojo/header-card'
};
export default css;
